import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { BsCalendar3, BsClock, BsArrowLeft } from "react-icons/bs";
import blogsData from "../../data/blogs.json";

function BlogDetail() {
  const { slug }   = useParams();
  const navigate   = useNavigate();
  const blog       = blogsData.find((b) => b.slug === slug);

  function goBack() {
    navigate("/");
    setTimeout(() => {
      document.getElementById("blog")?.scrollIntoView({ behavior: "smooth" });
    }, 300);
  }

  if (!blog) {
    return (
      <div className="blog-detail-page">
        <div className="blog-detail-inner" style={{ textAlign: "center", paddingTop: 80 }}>
          <h1 style={{ color: "var(--text)", marginBottom: 16 }}>Blog Not Found</h1>
          <p style={{ color: "var(--text-3)", marginBottom: 32 }}>
            The article you're looking for doesn't exist or has been removed.
          </p>
          <button className="blog-back-btn" onClick={goBack}>
            <BsArrowLeft /> Back to Blog
          </button>
        </div>
      </div>
    );
  }

  const { title, category, date, readTime, image, body } = blog;
  const formattedDate = new Date(date).toLocaleDateString("en-US", {
    year: "numeric", month: "long", day: "numeric",
  });

  return (
    <div className="blog-detail-page">
      <div className="blog-detail-inner">
        <button className="blog-back-btn" onClick={goBack}>
          <BsArrowLeft /> Back to Blog
        </button>

        <span className="blog-detail-cat">{category}</span>

        <h1 className="blog-detail-title">{title}</h1>

        <div className="blog-detail-meta">
          <span><BsCalendar3 />{formattedDate}</span>
          <span><BsClock />{readTime}</span>
        </div>

        <img src={image} alt={title} className="blog-detail-hero" />

        <div className="blog-detail-body">
          {body.map((block, i) => {
            if (block.type === "paragraph") return <p key={i}>{block.text}</p>;
            if (block.type === "heading")   return <h2 key={i}>{block.text}</h2>;
            if (block.type === "code")      return <pre key={i}><code>{block.text}</code></pre>;
            return null;
          })}
        </div>

        <div style={{ textAlign: "center", marginTop: 60, paddingBottom: 20 }}>
          <button className="blog-back-btn" onClick={goBack}>
            <BsArrowLeft /> Read More Articles
          </button>
        </div>
      </div>
    </div>
  );
}

export default BlogDetail;
